import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './routes/Home';
import AboutUs from './routes/AboutUs';
import Products from './routes/Products';
import Gallery from './routes/Gallery';
import News from './routes/News'; 
import ContactUs from './routes/ContactUs';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="/aboutus" element={<AboutUs />}/>
      <Route path="/products" element={<Products />}/>
      <Route path="/gallery" element={<Gallery />}/>
      <Route path="/news" element={<News />}/>
      <Route path="/contactus" element={<ContactUs />}/>
    </Routes>
  );
}

export default App;
